import { ISocialNetworkRepository } from '../../../domain/repositories/social-network.repository.interface';
import { SocialNetwork } from '../../../domain/entities/social-network.entity';

export class GetSocialNetworksUseCase {
  constructor(private readonly repository: ISocialNetworkRepository) {}

  public async execute(filters?: { activeOnly?: boolean }): Promise<SocialNetwork[]> {
    return this.repository.getAll(filters);
  }
}
